import { render, staticRenderFns } from "./orders-table.vue?vue&type=template&id=1d1877ae"
import script from "./orders-table.vue?vue&type=script&lang=js"
export * from "./orders-table.vue?vue&type=script&lang=js"
import style0 from "./orders-table.vue?vue&type=style&index=0&id=1d1877ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports